import { optionGroupLabelSx } from './listSubheaderProps'

/** Darker group labels for MUI Autocomplete (matches Select ListSubheader). */
export const autocompleteGroupedSlotProps = {
    popper: {
        sx: {
            '& .MuiAutocomplete-groupLabel': optionGroupLabelSx,
        },
    },
}
